export default __webpack_public_path__ + "static/media/ourclient4.9ce1d7a4.png";